import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export function exportMeasurementsFile({
  telemetryInfo,
  telemetrySelection,
  selectedOption,
  shipmentCode = "envio",
  variant = "full",
}) {
  const includeTemp = telemetrySelection.includes("temp");
  const includeHum = telemetrySelection.includes("humidity");
  const variantLabel = variant === "reduced" ? "Reducidas" : "Completas";

  if (!includeTemp && !includeHum) {
    throw new Error("Debe seleccionar Temperatura y/o Humedad.");
  }

  const sortedData = [...telemetryInfo].sort(
    (a, b) => new Date(a.date) - new Date(b.date),
  );

  const exportData = sortedData.map((item) => {
    const row = {};
    if (includeTemp) row["Temperatura (ºC)"] = item.temp.toFixed(2);
    if (includeHum) row["Humedad (%)"] = item.humidity.toFixed(2);
    row["Fecha y hora"] = item.date;
    return row;
  });

  const worksheet = XLSX.utils.json_to_sheet(exportData, {
    skipHeader: false,
  });

  const columnHeaders = Object.keys(exportData[0]);
  worksheet["!cols"] = columnHeaders.map((header) => ({
    wch: header.length + 5,
  }));

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Mediciones");

  const fileType = selectedOption === "csv" ? "csv" : "xlsx";
  const fileName = `Mediciones_${variantLabel}_${shipmentCode}.${fileType}`;

  if (selectedOption === "csv") {
    const csv = XLSX.utils.sheet_to_csv(worksheet, { FS: ";" });
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, fileName);
  } else {
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(blob, fileName);
  }
}
